const userTokenKey = "token";
const deviceTokenKey = "deviceToken";

const LocalStorageKeys = {
  userTokenKey,
  deviceTokenKey
};

export default LocalStorageKeys;
